import React from "react";
import SearchBox from "./SearchBox";

export default function BlogSearch() {
  return (
    <div className="mb-8">
      <SearchBox />
    </div>
  );
}
